import { render, staticRenderFns } from "./Dialog_CreateSchoolExam.vue?vue&type=template&id=3132a2b0&scoped=true&"
import script from "./Dialog_CreateSchoolExam.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateSchoolExam.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_CreateSchoolExam.vue?vue&type=style&index=0&id=3132a2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132a2b0",
  null
  
)

export default component.exports